/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentMessageTemplateRequest model module.
 * @module model/AgentMessageTemplateRequest
 * @version 1.0.0
 */
class AgentMessageTemplateRequest {
    /**
     * Constructs a new <code>AgentMessageTemplateRequest</code>.
     * @alias module:model/AgentMessageTemplateRequest
     * @param title {String} テンプレートタイトル
     * @param content {String} テンプレート内容
     * @param templateType {module:model/AgentMessageTemplateRequest.TemplateTypeEnum} テンプレートタイプ
     */
    constructor(title, content, templateType) { 
        
        AgentMessageTemplateRequest.initialize(this, title, content, templateType);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, title, content, templateType) { 
        obj['title'] = title;
        obj['content'] = content;
        obj['template_type'] = templateType;
    }

    /**
     * Constructs a <code>AgentMessageTemplateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentMessageTemplateRequest} obj Optional instance to populate.
     * @return {module:model/AgentMessageTemplateRequest} The populated <code>AgentMessageTemplateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentMessageTemplateRequest();

            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('template_type')) {
                obj['template_type'] = ApiClient.convertToType(data['template_type'], 'String');
            }
            if (data.hasOwnProperty('order')) {
                obj['order'] = ApiClient.convertToType(data['order'], 'Number');
            }
            if (data.hasOwnProperty('short_appeal_message')) {
                obj['short_appeal_message'] = ApiClient.convertToType(data['short_appeal_message'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentMessageTemplateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentMessageTemplateRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AgentMessageTemplateRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
            throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
        }
        // ensure the json data is a string
        if (data['template_type'] && !(typeof data['template_type'] === 'string' || data['template_type'] instanceof String)) {
            throw new Error("Expected the field `template_type` to be a primitive type in the JSON string but got " + data['template_type']);
        }
        // ensure the json data is a string
        if (data['short_appeal_message'] && !(typeof data['short_appeal_message'] === 'string' || data['short_appeal_message'] instanceof String)) {
            throw new Error("Expected the field `short_appeal_message` to be a primitive type in the JSON string but got " + data['short_appeal_message']);
        }

        return true;
    }


}

AgentMessageTemplateRequest.RequiredProperties = ["title", "content", "template_type"];

/**
 * テンプレートタイトル
 * @member {String} title
 */
AgentMessageTemplateRequest.prototype['title'] = undefined;

/**
 * テンプレート内容
 * @member {String} content
 */
AgentMessageTemplateRequest.prototype['content'] = undefined;

/**
 * テンプレートタイプ
 * @member {module:model/AgentMessageTemplateRequest.TemplateTypeEnum} template_type
 */
AgentMessageTemplateRequest.prototype['template_type'] = undefined;

/**
 * 表示順
 * @member {Number} order
 */
AgentMessageTemplateRequest.prototype['order'] = undefined;

/**
 * @member {String} short_appeal_message
 */
AgentMessageTemplateRequest.prototype['short_appeal_message'] = undefined;





/**
 * Allowed values for the <code>template_type</code> property.
 * @enum {String}
 * @readonly
 */
AgentMessageTemplateRequest['TemplateTypeEnum'] = {

    /**
     * value: "investment"
     * @const
     */
    "investment": "investment",

    /**
     * value: "assessment"
     * @const
     */
    "assessment": "assessment"
};



export default AgentMessageTemplateRequest;

